<template lang="pug">
.guidelines
  .guidelines__heading {{ config.guidelinesHeading }}
  .guidelines__row.single
    .guidelines__static State
    .guidelines__value {{ results.state }}
  .guidelines__row.single
    .guidelines__static Original Signature
    .guidelines__value {{ results.originalSignature }}
  .guidelines__row.single
    .guidelines__static State Filing Fee
    .guidelines__value {{ populateCell(results.stateFilingFee) }}
  .guidelines__row.single
    .guidelines__static Supporting Document(s)
    .guidelines__value {{ results.supportingDocuments }}
  .guidelines__row
    .guidelines__static Pre-Clearance Option(s)
    .guidelines__value
      table.guidelines__table(v-if="results.supportingDocuments.length && results.preClearanceOptions.length")
        thead
          tr
            th(v-for="item in config.tableColumns" :style="`width: ${item.width}px`")
              div
                label {{ item.label }}
        tbody
          tr(v-for="row in results.preClearanceOptions")
            td(v-for="column in config.tableColumns")
              div
                label(v-html="populateCell(row[column.field])")
      template(v-else)
        span No Pre-Clearance
  .guidelines__row
    .guidelines__static Expedite Option(s)
    .guidelines__value
      table.guidelines__table(v-if="results.supportingDocuments.length && results.expediteOptions.length")
        thead
          tr
            th(v-for="item in config.tableColumns" :style="`width: ${item.width}px`")
              div
                label {{ item.label }}
        tbody
          tr(v-for="row in results.expediteOptions")
            td(v-for="column in config.tableColumns")
              div
                label.guidelines__table-label(v-html="populateCell(row[column.field])")
      template(v-else)
        span N/A
  .guidelines__row.single
    .guidelines__static Form(s)
    template(v-if="results.documents && results.documents.length")
      table.guidelines__table
        tbody
          tr(
            v-for="document in results.documents"
            :key="document.documentId")
            td
              a.guidelines__value.guidelines__link(
                :href="document.documentLocation"
                target="_blank") {{ document.form }}
    template(v-else)
      span N/A
  .guidelines__row.single
    .guidelines__static Note(s)
    .guidelines__value(v-html="results.notes")
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FilingGuidelinesGuidelines",
  components: {
  },
  data: function () {
    return {
    };
  },
  computed: {
    ...mapGetters(["config", "results"]),
  },
  methods: {
    populateCell(val) {
      // Return if the value is null so it doesn't try to format it as "$0.00".
      if (val === null || val === undefined || typeof val === 'string') {
        return val;
      } else {
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',

          // These options are needed to round to whole numbers if that's what you want.
          //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
          //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
        });
        return formatter.format(val)
      }
    }

  }
};
</script>

<style scoped lang="scss">
.guidelines {
  &__heading {
    text-transform: uppercase;
    margin: auto 0;
    color: $darkGray;
    letter-spacing: 1.6px;
    padding-bottom: 1rem;
    font-weight: 600;

    @include mqdn(lg) {
      text-align: center;
    }
  }

  &__row {
    display: flex;
    gap: 1rem;
    padding-bottom: 1rem;

    @include mqdn(lg) {
      flex-direction: column;

      &.single {
        border-bottom: 1px solid #DADBDC;
        margin-bottom: 1rem;
      }
    }
  }

  &__static {
    flex: 0 0 20rem;
    text-transform: uppercase;
    color: $darkGray;
    letter-spacing: 1.6px;

    @include mqdn(lg) {
      flex: 1;
    }
  }

  &__link {
    color: $orange;
  }

  &__value {
    display: flex;
    flex-direction: column;
    overflow: auto;
    flex: 1;

    &.guidelines__link {
      flex: unset;
    }
  }

  &__table {
    width: 100%;
    max-width: 100%;
    border-collapse: collapse;

    thead {
      border-bottom: 1px solid $orange;

      th {
        font-size: 1rem;
        top: 0;
        text-transform: uppercase;
        color: $darkGray;
        font-weight: 500;
        letter-spacing: 1.6px;
      }
    }

    tbody {

      tr {
        font-size: 1rem;
        color: $darkGray;
        font-weight: 400;
        border-bottom: 1px solid #DADBDC;
      }
    }

    th {
      height: 1.75rem;
    }

    td {
      height: 2.75rem;
    }

    td,
    th {
      width: auto;
      text-align: left;

      div {
        padding: 0 1rem 0 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      label {
        white-space: nowrap;
      }
    }

    &-label {
      padding: 0.5rem;
    }
  }
}
</style>
